import { assertInvariants, hydrateState } from './simulation.js';

export const STORAGE_KEY = 'incoprea.trading-post.save.v1';

function checksum(text) {
  let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
}

function resolveStorage(storage) {
  const target = storage ?? globalThis.localStorage;
  if (!target || typeof target.getItem !== 'function' || typeof target.setItem !== 'function') {
    throw new Error('A Web Storage-compatible object is required');
  }
  return target;
}

export function serializeState(state) {
  assertInvariants(state);
  const payload = JSON.stringify(state);
  return JSON.stringify({
    format: 'incoprea-trading-post',
    version: 1,
    checksum: checksum(payload),
    payload,
  });
}

export function deserializeState(serialized) {
  if (typeof serialized !== 'string' || serialized.length === 0) throw new Error('Save data is empty');
  let envelope;
  try {
    envelope = JSON.parse(serialized);
  } catch {
    throw new Error('Save data is not valid JSON');
  }
  if (envelope?.format !== 'incoprea-trading-post' || envelope.version !== 1 || typeof envelope.payload !== 'string') {
    throw new Error('Save data uses an unsupported format');
  }
  if (checksum(envelope.payload) !== envelope.checksum) throw new Error('Save data checksum does not match');
  let state;
  try {
    state = JSON.parse(envelope.payload);
  } catch {
    throw new Error('Save payload is not valid JSON');
  }
  const hydrated = hydrateState(state);
  assertInvariants(hydrated);
  return hydrated;
}

export function saveState(state, storage) {
  const target = resolveStorage(storage);
  target.setItem(STORAGE_KEY, serializeState(state));
  return state;
}

export function loadState(storage) {
  const target = resolveStorage(storage);
  const serialized = target.getItem(STORAGE_KEY);
  return serialized == null ? null : deserializeState(serialized);
}

export function clearState(storage) {
  resolveStorage(storage).removeItem(STORAGE_KEY);
}

export const saveGame = saveState;
export const loadGame = loadState;
export const clearSavedGame = clearState;
